<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg5>
            <h2>{{ $t("Toolbar.announce") }}</h2>
          </v-flex>
          <v-flex xs11 lg6 class="text-end"> </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-3 pb-3>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg pb-2">
              <v-tabs v-model="tab" align-with-title color="#077893">
                <v-tabs-slider color="#077893"></v-tabs-slider>
                <v-tab v-for="item in items" :key="item">
                  {{ $t(item) }}
                </v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <EmployeeOneID />
                </v-tab-item>
                <v-tab-item>
                  <EmployeeCMP />
                </v-tab-item>
              </v-tabs-items>
            </v-card>
          </v-flex>
        </v-layout>
        <SendOnechatDetail />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import EmployeeOneID from "@/views/Admin/Announce/OnePlatform/EmployeeAnnounce.vue";
import EmployeeCMP from "@/views/Admin/Announce/OnePlatform/EmployeeAnnounceCMP";
import SendOnechatDetail from "@/views/Admin/Announce/OnePlatform/SendAnnounceDetail";
export default {
  components: {
    EmployeeCMP,
    EmployeeOneID,
    // LogOnechat,
    SendOnechatDetail,
  },
  data: function () {
    return {
      tab: null,
      items: [this.$t("onechat.new1"), this.$t("onechat.new2")],
    };
  },
};
</script>
<style scoped>
.bg-color {
  background-color: #ddf7ff;
}

.v-stepper__content {
  padding: 0 !important;
}

.c-border {
  border-style: solid;
  border-color: #87e8de !important;
  border-width: 1px;
}

.--text {
  color: #13c2c2;
}

.ff3296--text {
  color: #ff3296;
}
</style>

<style>
input#input-45,
input#input-50 {
  cursor: pointer !important;
}
</style>

